// DESIGN.md §10.4 (AC-11): the two `/daftar` paths must not borrow each other's words. This file
// is the one place that copy is written for both paths, so the ban is easy to audit in one read;
// `onboarding.test.tsx` runs every string here through `checkVocabulary` for its own surface.
// SPEC §6 "Bahasa dan nada": two tones under one identity — Urun (aman, bergotong-royong) and
// Rumah (hangat, memberdayakan) — carried here by word choice, not by a different type system.
export type OnboardingPath = 'urun' | 'rumah';

export interface OnboardingCopy {
  heading: string;
  intro: string;
  fullNameLabel: string;
  fullNameHint?: string;
  phoneLabel?: string;
  accountConsentLabel: string;
  dataConsentLabel: string;
  submitLabel: string;
  successHeading: string;
  successMessage: string;
}

export const ONBOARDING_COPY: Readonly<Record<OnboardingPath, OnboardingCopy>> = {
  urun: {
    heading: 'Daftar sebagai investor',
    intro:
      'Ikut memiliki sebagian rumah bersama warga lain, dengan bagian hasil yang berasal dari pembayaran bulanan yang nyata dari calon pemilik rumah. Setelah akun aktif, Anda perlu melewati verifikasi identitas sebelum dapat membeli.',
    fullNameLabel: 'Nama lengkap sesuai KTP',
    fullNameHint: 'Harus sama dengan nama di rekening bank Anda.',
    accountConsentLabel: 'Saya menyetujui pembuatan akun ini dan Syarat Penggunaan URUNRUMAH.',
    dataConsentLabel: 'Saya menyetujui pemrosesan data pribadi saya sesuai Kebijakan Privasi.',
    submitLabel: 'Buat akun investor',
    successHeading: 'Akun investor Anda sudah aktif',
    successMessage: 'Selanjutnya lengkapi verifikasi identitas sebelum memulai.',
  },
  rumah: {
    heading: 'Daftar untuk memiliki rumah',
    intro:
      'Ajukan diri untuk tinggal dan berangsur menjadi pemilik rumah, dengan penilaian yang mempertimbangkan bukti penghasilan sehari-hari Anda.',
    fullNameLabel: 'Nama lengkap',
    phoneLabel: 'Nomor telepon',
    accountConsentLabel: 'Saya menyetujui pembuatan akun ini dan Syarat Penggunaan URUNRUMAH.',
    dataConsentLabel: 'Saya menyetujui pemrosesan data pribadi saya sesuai Kebijakan Privasi.',
    submitLabel: 'Buat akun',
    successHeading: 'Akun Anda sudah aktif',
    successMessage: 'Selanjutnya lengkapi pengajuan diri Anda.',
  },
} as const;

/** api-contract.yaml `RegisterRequest.consents` example date; a separate value from `VOCAB_VERSION`
 * — this is the registration consent text's own version, not one of the §10.3 constants. */
export const CONSENT_TEXT_VERSION = '2026-09-01';
